import type { ProdutoResumo } from '@peniel/shared'
import { mensagemInteresse, montarLinkWhatsapp } from '@peniel/shared'

import { LinkBotao, type TamanhoBotao, type VarianteBotao } from '@/shared/ui/Botao.jsx'
import { useConfigLoja } from '@/shared/hooks/useConfigLoja.js'

interface PropsBotaoWhatsAppProduto {
  produto: ProdutoResumo
  variante: VarianteBotao
  tamanho?: TamanhoBotao
  forma?: 'pill' | 'caixa' | 'caixa-sm'
  rotulo: string
  blocoCompleto?: boolean
  className?: string
}

/**
 * Botão "tenho interesse" de um produto.
 *
 * Manda o link da bike na mensagem além do nome: sem ele, o lojista recebe
 * "tenho interesse na Caloi Aspen" e precisa caçar qual é no painel; com ele,
 * é um toque.
 */
export function BotaoWhatsAppProduto({
  produto,
  variante,
  tamanho = 'md',
  forma = 'caixa',
  rotulo,
  blocoCompleto = true,
  className,
}: PropsBotaoWhatsAppProduto) {
  const config = useConfigLoja()
  const url = `${window.location.origin}/bicicletas/${produto.slug}`
  const mensagem = mensagemInteresse(produto, url)

  return (
    <LinkBotao
      href={montarLinkWhatsapp(config.whatsappNumero, mensagem)}
      externo
      variante={variante}
      tamanho={tamanho}
      forma={forma}
      icone="whatsapp"
      blocoCompleto={blocoCompleto}
      className={className}
      aria-label={`Falar no WhatsApp sobre ${produto.nome} (abre em nova aba)`}
    >
      {rotulo}
    </LinkBotao>
  )
}

/** Botão de WhatsApp genérico (nav, hero, faixa de troca). */
export function BotaoWhatsAppGeral({
  mensagem,
  variante,
  tamanho = 'md',
  forma = 'pill',
  children,
  blocoCompleto = false,
  className,
  aoClicar,
}: {
  mensagem: string
  variante: VarianteBotao
  tamanho?: TamanhoBotao
  forma?: 'pill' | 'caixa' | 'caixa-sm'
  children: string
  blocoCompleto?: boolean
  className?: string
  /** Efeito colateral no clique — ex.: fechar o menu mobile. */
  aoClicar?: () => void
}) {
  const config = useConfigLoja()

  return (
    <LinkBotao
      href={montarLinkWhatsapp(config.whatsappNumero, mensagem)}
      externo
      variante={variante}
      tamanho={tamanho}
      forma={forma}
      icone="whatsapp"
      blocoCompleto={blocoCompleto}
      className={className}
      {...(aoClicar ? { onClick: aoClicar } : {})}
      aria-label={`${children} pelo WhatsApp (abre em nova aba)`}
    >
      {children}
    </LinkBotao>
  )
}
